import React from 'react';
import { Box } from '@mui/material';
import { getDAWType } from '../../utils/fileUtils';
import { DAWInfoChip } from './InfoChip';
import { DAWType } from '@/types/daw';

export { DAWType };

interface DAWLogoProps {
  dawType?: DAWType;
  filename?: string;
  variant?: 'chip' | 'icon';
  size?: 'small' | 'medium' | 'large';
}

const DAWLogo: React.FC<DAWLogoProps> = ({
  dawType,
  filename,
  variant = 'chip',
  size = 'medium',
}) => {
  // Determine DAW type from filename if not provided
  let finalDAWType = dawType;
  if (!finalDAWType && filename) {
    const dawTypeFromFile = getDAWType(filename);
    // Map the string to DAWType
    const dawTypeMap: Record<string, DAWType> = {
      'Ableton Live': DAWType.ABLETON,
      'Logic Pro X': DAWType.LOGIC,
      'Pro Tools': DAWType.PRO_TOOLS,
      Cubase: DAWType.CUBASE,
      'FL Studio': DAWType.FL_STUDIO,
      REAPER: DAWType.REAPER,
    };
    finalDAWType = dawTypeMap[dawTypeFromFile] || DAWType.UNKNOWN;
  }

  if (!finalDAWType) {
    finalDAWType = DAWType.UNKNOWN;
  }

  if (variant === 'icon') {
    // For icon variant, return a simple colored circle or icon
    const iconSize = size === 'small' ? 16 : size === 'medium' ? 20 : 48;
    const fontSize =
      size === 'small' ? '8px' : size === 'medium' ? '10px' : '20px';
    return (
      <Box
        sx={{
          width: iconSize,
          height: iconSize,
          borderRadius: '50%',
          backgroundColor: 'action.disabledBackground',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: fontSize,
          color: 'white',
          fontWeight: 'bold',
        }}
        title={finalDAWType}
      >
        {finalDAWType.charAt(0).toUpperCase()}
      </Box>
    );
  }

  if (variant === 'chip') {
    // Use the new DAWInfoChip which includes icons
    return (
      <DAWInfoChip dawType={finalDAWType} size={size} variant="outlined" />
    );
  }

  return null;
};

export default DAWLogo;
